export const ENV = {}

// Current Environment
ENV.environment = 'production'

ENV.version = '1.7.0'
ENV.buildNumber = 'f1948d4c'

//BioConnect Link GraphQL API
/*
 * Prod: 'https://apiprod.app.bioconnect.com'
 * Staging: 'https://apistage.app.bioconnect.com'
 * QA: 'https://apiqa.app.bioconnect.com'
 * Dev: 'https://apidev.app.bioconnect.com'
 */
ENV.ENDPOINT_URL = 'https://apiprod.app.bioconnect.com'

// Hubspot Credentials
ENV.hubspot_portal_id = '46442349'
ENV.hubspot_form_id = '4d735956-b8ca-4d7c-b871-e36fc3600b3c'
ENV.hubspot_general_form_id = 'dea9ab20-6b64-4a44-a726-a8a62d51110d'

// Inactivity Timeouts (in seconds)
ENV.IDLE_TIMEOUT = 900
ENV.IDLE_WARNING_TIME = 30

// Token refresh interval
ENV.REFRESH_TOKEN_THRESHOLD = 60
